/**
 * @author Kelnik
 *
 * MultiSelect - Мульти селект
 */

import Utils from 'common/scripts/utils';

class MultiSelect {
    constructor(options) {
        this.options = options;
        this.container = document.querySelector(options.container);

        if (!this.container) {
            console.error(`element with selector "${options.container}" not found!`);

            return;
        }

        this.inputSelector = '.j-multi-select-input';
        this.contentSelector = '.j-multi-select-content';
        this.textValueSelector = '.j-multi-select-value';
        // Checkbox'ы нижнего уровня
        this.itemInputSelector = '.j-multi-select-item-input';

        this.contentShowClass = 'multi-select__content_is_open';
        this.closeSelector = '.j-multi-select-close';
    }

    init() {
        if (!this.container) {
            return;
        }

        this._initElements();
        this._bindEvents();

        this.placeholder = this.textValue.innerHTML;
    }

    _initElements() {
        this.input = this.container.querySelector(this.inputSelector);
        this.content = this.container.querySelector(this.contentSelector);
        this.textValue = this.container.querySelector(this.textValueSelector);
        this.itemInputs = Array.from(this.container.querySelectorAll(this.itemInputSelector));
        this.closes = Array.from(this.container.querySelectorAll(this.closeSelector));
    }

    _bindEvents() {
        this.input.addEventListener('click', () => {
            if (this._isVisibleContent()) {
                this._closeContent(false);
            } else {
                this._openContent();
            }
        });

        this.itemInputs.forEach((itemInput) => {
            itemInput.addEventListener('change', () => {
                const text = this._collectText();
                const valEl = this.itemInputs.filter((item) => {
                    return item.checked;
                });
                const val = valEl.map((item) => {
                    return item.value;
                });

                this._insertTextValue(text);

                if (this.options.afterChange) {
                    this.options.afterChange(val);
                }
            });
        });

        this.closes.forEach((close) => {
            close.addEventListener('click', (event) => {
                event.preventDefault();

                this._closeContent();
            });
        });

        Utils.clickOutside(this.options.container, () => {
            this._closeContent(false);
        });
    }

    _isVisibleContent() {
        return Boolean(this.content.classList.contains(this.contentShowClass));
    }

    _openContent() {
        this.content.classList.add(this.contentShowClass);

        if (window.innerWidth < 670) {
            Utils.bodyFixed(this.content);
        }
    }

    _closeContent(toStaticBody = true) {
        this.content.classList.remove(this.contentShowClass);

        if (toStaticBody) {
            Utils.bodyStatic();
        }
    }

    // Строит строку из data-text инпутов
    _collectText() {
        let result = '';

        this.itemInputs.forEach((input) => {
            const text = input.checked ? `${input.dataset.text}, ` : '';

            result = result + text;
        });

        result = result.slice(0, -2);

        if (!result) {
            result = this.placeholder;
        }

        return result;
    }

    _insertTextValue(text) {
        Utils.clearHtml(this.textValue);
        Utils.insetContent(this.textValue, text);
    }

    setVal(val = []) {
        this.itemInputs.forEach((input) => {
            input.checked = val.indexOf(input.value) !== -1;
        });

        const text = this._collectText();

        this._insertTextValue(text);
    }

    getValues() {
        const checked = this.itemInputs.filter((item) => {
            return item.checked;
        });

        return checked.map((item) => {
            return item.value;
        });
    }

    reset() {
        this.itemInputs.forEach((input) => {
            input.checked = false;
        });

        this._insertTextValue(this.placeholder);
    }
}

export default MultiSelect;
